import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/modules/settings/selectors";
import messages from "rdx/modules/settings/messages";
import { keysToCamelCase } from "lib/helpers";

function* updateAdminBatteryServiceArea(action) {
  const { success, data, error } = yield* makeRequest.put(
    `/battery_service_areas/${action.payload.state}`,
    action.payload,
  );

  if (success && data) {
    let out;
    if (data.body.battery_service_areas) {
      out = data.body.battery_service_areas.map((s) => keysToCamelCase(s));
    } else {
      out = yield select(selectors.getAdminBatteryServiceAreas);
    }
    yield all([
      put(actions.setAdminBatteryServiceAreas(out)),
      put(
        actions.newSuccessEvent({
          message: messages.BATTERY_SERVICE_AREA_UPDATE_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_UPDATING_BATTERY_SERVICE_AREA,
    });
  }

  return null;
}

export default updateAdminBatteryServiceArea;
